import { VMoney } from "v-money";

export function parseToMoney (value) {
    if (!value) value = 0;
    if (typeof value == 'string' && value.includes('$')){
        return value;
    }else{
        return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP'}).format(value);
    }
}

// Formato compacto para axes de charts: `$35M`, `$1,2M`, `$500K`, `$0`. CLP
// no se imprime con decimales nunca; en valores entre 1K y 1M dejamos 0 o 1
// decimal según el orden de magnitud para evitar que `$1500K` desentone con
// `$2M` en la misma escala. Si en algún tab querés simbolo distinto (USD,
// EUR), abstraé el `$` a un parámetro — hoy todo el módulo es CLP.
export function parseToCompactMoney (value) {
    const v = Number(value || 0);
    const abs = Math.abs(v);
    const sign = v < 0 ? "-" : "";
    if (abs >= 1e9) return `${sign}$${(abs / 1e9).toFixed(abs % 1e9 === 0 ? 0 : 1).replace(".", ",")}B`;
    if (abs >= 1e6) return `${sign}$${(abs / 1e6).toFixed(abs % 1e6 === 0 ? 0 : 1).replace(".", ",")}M`;
    if (abs >= 1e3) return `${sign}$${Math.round(abs / 1e3)}K`;
    return `${sign}$${Math.round(abs)}`;
}

export const configMoney = {
    decimal: ",",
    thousands: ".",
    prefix: "$ ",
    suffix: "",
    precision: 0,
    allowBlank: true,
}

export const Money = VMoney
